<template>
    <div class="w-full px-20 grid grid-cols-1 xl:grid-cols-2 gap-16">
        <div v-if="!boosters.length" class="flex justify-center col-span-2">
             <loading></loading>
        </div>
        <div
            v-else
            v-for="booster in boosters"
            class="flex flex-col rounded-sm border p-24 gap-3 overflow-hidden shadow"
        >
            <div class="rounded bg-primary-5">
                <div class="flex h-48 items-center flex-start pl-5">
                    <svg-icon v-if="booster.media['google']" type="google" class="w-18 h-18 mr-3" />
                    <img v-if="booster.media.instagram" src="/app/img/instagram.svg" alt="Instagram" class="w-18 h-18 mr-3">
                    <svg-icon v-if="booster.media['facebook-large']" type="facebook" class="w-18 h-18 mr-3" />
                </div>
                <div class="h-[304px] relative -top-16">
                    <img :src="booster.icon" :alt="`logo-${booster.title[locale]}`" style="object-fit: contain; width: 100%; height: 100%;">
                </div>
                <div class="ml-12 mb-12">
                    <tag>
                        {{ $t('general.premium') }}
                    </tag>
                </div>
            </div>
            <div class="flex items-center">
                <span class="text-heading-2 mr-2.5">{{ booster.title[locale] }}</span>
                <svg-icon class="w-24 h-24 text-orange" v-if="booster.spotlight" type="star-filled"></svg-icon>
            </div>
            <span class="font-semibold">{{ currency.sign + booster.price.toFixed(2) }}</span>
            <p v-html="booster.short_description[locale]"></p>
            <div class="flex-grow"></div>
            <div class="flex flex-col gap-5">
                <simple-button
                    display="secondary"
                    look="primary"
                    class="w-full"
                    :uppercase="false"
                    @click="addToCampaign(booster)">
                    {{ $t('multi-posting.contracts.index.add_to_campaign') }}
                </simple-button>
                <simple-button
                    class="w-full"
                    :uppercase="false"
                    @click="viewDetails(booster)">
                    {{ $t('multi-posting.contracts.index.details') }}
                </simple-button>
            </div>
        </div>
    </div>
</template>

<script>
import SvgIcon from "../../ui/SvgIcon.vue";
import SimpleButton from "../../ui/SimpleButton.vue";
import SelectDropdown from "../../forms/SelectDropdown.vue";
import {getSymbol} from "../../../etc/currency";
import {mapState} from "pinia";
import {useMainStore} from '../../../state/store';
import {useMultiPostingStore} from '../../../state/modules/multiPosting';
import Loading from "../../ui/Loading.vue";
import Tag from "../../ui/Tag.vue";

export default {
    name: 'SocialBoostGrid',
    components: {
        SimpleButton,
        SvgIcon,
        SelectDropdown,
        Loading,
        Tag
    },
    computed: {
        ...mapState(useMainStore, ['selectedLocale']),
        ...mapState(useMultiPostingStore, ['boosters']),
        locale() {
            return this.selectedLocale;
        },
        currency() {
            return getSymbol();
        },
    },
    methods: {
        addToCampaign(booster) {
            this.$emit('add-to-campaign', booster);
        },
        viewDetails(booster) {
            this.$emit('selected-booster', booster);
        }
    }
}
</script>

